import { Fragment, useState, useEffect } from "react";
import { Searcher, TableAntd } from "../../components/commons";
import { columnsParticipantes } from "./formatTable";
import { CodeSandboxOutlined, FileExcelOutlined, ClearOutlined } from "@ant-design/icons";
import { Button, Upload, Spin, Result, Modal, message } from "antd";
import { getParticipantes, getGanadores, downloadExcelGanadores } from "../../api/sorteo";
import { BASE_PATH, API_VERSION } from "../../api/api";
import { ACCESS_TOKEN } from "../../api/auth";
import { useLocation, useHistory } from "react-router-dom";
import SortearDeleteParticipantes from "./SortearDeleteParticipantes";
import SortearModalSortear from "./SortearModalSortear";
import SortearModalPublicar from "./SortearModalPublicar";

function Sortear() {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const codigosorteo = query.get("codigo");

  const [page, setPage] = useState(1);
  const [filterTable, setFilterTable] = useState(null);
  const [filterTableGanadores, setFilterTableGanadores] = useState(null);
  const [participante, setParticipante] = useState([]);
  const [ganadores, setGanadores] = useState([]);

  const [recordSorteo, setRecordSorteo] = useState({
    nombre: "",
    isActivo: null
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const [isUploading, setIsUploading] = useState(false);

  const fetchParticipantes = async () => {
    try {
      setIsLoading(true);
      const res = await getParticipantes();
      setParticipante(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
      setParticipante([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchGanadores = async () => {
    try {
      if (codigosorteo) {
        const res = await getGanadores(codigosorteo);
        setGanadores(res.payload.ganadores);
        setRecordSorteo(res.payload.sorteo);
      }
    } catch (error) {
      setGanadores([]);
    }
  };

  useEffect(() => {
    fetchParticipantes();
    fetchGanadores();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  const onSearch = (value) => {
    const tempFilterTable = participante.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  const onSearchGanadores = (value) => {
    const tempFilterTable = ganadores.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTableGanadores(tempFilterTable);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  // ------ Show modal delete record -----------
  const showDeleteModal = () => {
    setIsModalVisible(true);
    setModalTitle("Limpiar participantes");
    setModalContent(
      <SortearDeleteParticipantes closeModal={closeModal} fetchData={fetchParticipantes} />
    );
  };

  const columnsToTable = columnsParticipantes(page);

  // Subir participante
  const uploadParticipantesSorteoProps = {
    name: "sor_participante",
    action: `${BASE_PATH}/${API_VERSION}/sorteo/upload-participantes`,
    headers: { authorization: ACCESS_TOKEN },
    onChange(info) {
      if (info.file.status !== "uploading") {
        setIsUploading(true);
      }
      if (info.file.status === "done") {
        setIsUploading(false);
        fetchParticipantes();
        message.success(`${info.file.name} subido correctamente`);
      } else if (info.file.status === "error") {
        setIsUploading(false);
        message.error(`${info.file.name} falló en subir.`);
      }
    }
  };

  // ------ Sortear -----------
  const showSortearModal = () => {
    setIsModalVisible(true);
    setModalTitle("Limpiar participantes");
    setModalContent(<SortearModalSortear closeModal={closeModal} fetchData={fetchParticipantes} />);
  };

  const limpiarGanadores = () => {
    history.push("/app/sortear");
  };

  // ------------- Descarga ganadores por codigo -------------
  const onDownloadGanadoresExcel = async () => {
    const blob = await downloadExcelGanadores(codigosorteo);

    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `sorteo-${codigosorteo}.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
  };

  // ------ Publicar -----------
  const showPublicarModal = () => {
    setIsModalVisible(true);
    setModalTitle("Publicar sorteo");
    setModalContent(
      <SortearModalPublicar
        closeModal={closeModal}
        codigo={codigosorteo}
        setRecordSorteo={setRecordSorteo}
      />
    );
  };

  return (
    <Fragment>
      <div className="w-full flex gap-10">
        <div className="w-full lg:w-1/2">
          <div className="flex gap-2 my-4">
            <span className="text-lg font-bold uppercase">
              ({participante.length || "0"}) Participantes del sorteo
            </span>
            <div className="flex gap-1 flex-col flex-wrap  md:flex-row md:flex-nowrap">
              <Upload showUploadList={false} {...uploadParticipantesSorteoProps} accept=".xlsx">
                <Button
                  disabled={participante.length}
                  loading={isUploading}
                  icon={<FileExcelOutlined />}
                  className="text-white rounded-md text-xs bg-green-500 hover:bg-green-600 hover:shadow-lg"
                >
                  Importar
                </Button>
              </Upload>

              <Button
                disabled={!participante.length}
                onClick={() => showDeleteModal()}
                icon={<ClearOutlined />}
                className="text-white rounded-md text-xs bg-purple-500 hover:bg-purple-600 hover:shadow-lg"
              >
                Limpiar
              </Button>

              <Button
                disabled={!participante.length || ganadores.length}
                onClick={() => showSortearModal()}
                icon={<CodeSandboxOutlined />}
                className="text-white rounded-md text-xs bg-blue-500 hover:bg-blue-600 hover:shadow-lg"
              >
                Sortear
              </Button>
            </div>
          </div>
          <div className="w-full">
            <Searcher onSearch={onSearch} placeholder="Buscar participante" />
            <TableAntd
              columns={columnsToTable}
              dataSource={filterTable == null ? participante : filterTable}
              pageSize={100}
              setPage={setPage}
            />
          </div>
        </div>

        <div className="w-full lg:w-1/2">
          <div className="flex gap-2 my-4">
            <span className="text-lg font-bold uppercase">
              ({ganadores.length || 0}) Ganadores del sorteo
            </span>

            <div className="flex gap-1 flex-col flex-wrap  md:flex-row md:flex-nowrap">
              <Button
                disabled={!ganadores.length}
                onClick={() => limpiarGanadores()}
                icon={<ClearOutlined />}
                className="text-white rounded-md text-xs bg-purple-500 hover:bg-purple-600 hover:shadow-lg"
              >
                Limpiar
              </Button>

              <Button
                disabled={!ganadores.length}
                onClick={onDownloadGanadoresExcel}
                icon={<FileExcelOutlined />}
                className="text-white rounded-md text-xs bg-green-500 hover:bg-green-600 hover:shadow-lg"
              >
                Descargar
              </Button>

              <Button
                disabled={!ganadores.length}
                onClick={() => showPublicarModal()}
                icon={<CodeSandboxOutlined />}
                className="text-white rounded-md text-xs bg-blue-500 hover:bg-blue-600 hover:shadow-lg"
              >
                Publicar
              </Button>
            </div>
          </div>
          <div className="w-full">
            {codigosorteo && (
              <div className="flex justify-between mt-2 text-base">
                <div>
                  Nombre:&nbsp;
                  <span className="font-bold text-blue-500">{recordSorteo.nombre}</span>
                </div>

                <div>
                  &nbsp;Código:&nbsp;
                  <span className="font-bold text-blue-500">{codigosorteo}</span>
                </div>

                <div>
                  &nbsp;Publicado:&nbsp;
                  <span className="font-bold text-blue-500">
                    {recordSorteo.isActivo ? "Sí" : "No"}
                  </span>
                </div>
              </div>
            )}

            <Searcher onSearch={onSearchGanadores} placeholder="Buscar participante sorteado" />
            <TableAntd
              columns={columnsToTable}
              dataSource={filterTableGanadores == null ? ganadores : filterTableGanadores}
              pageSize={100}
              setPage={setPage}
            />
          </div>
        </div>
      </div>

      <Modal
        title={modalTitle}
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        maskClosable={false}
        width="40%"
      >
        {modalContent}
      </Modal>
    </Fragment>
  );
}

export default Sortear;
